module.exports = __webpack_public_path__ + "media/music/punchy_bass_4-f66a56f6.mp3";